import React, { useEffect, useState } from 'react';
import ModalFormPaintwork from '../../components/forms/config/modal.form.paintwork'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListPaintworks() {
  const [msgGet ,setMsgGet] = useState('');
  const [fluids,setPaintworks] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getPaintWork()
  }, []);

  const createPaintWork = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getPaintWork()
  };


  const editButton = (row) => {
    return (
      <ModalFormPaintwork
        title="Modificar Novedad pintura"
        button_text="Editar"
        button_variant="outline-primary"
        paintworkSelect={row.id}
        callback={createPaintWork}
      ></ModalFormPaintwork>
    );
  };

  const getPaintWork = async()=>{
    const responseFluids = await get('/config/paintwork/',{})
    if(responseFluids.success){
      setPaintworks(responseFluids.data);
    }else{
      setMsgGet(responseFluids.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormPaintwork
        title="Crear Novedad pintura"
        button_text="Crear Novedad pintura"
        button_variant="primary"
        callback={createPaintWork}
      ></ModalFormPaintwork>
      <ListTables
        data={fluids}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListPaintworks;
